import { useCompositionStore } from "../../stores/compositionStore.js";
import { Badge } from "../../ui/Badge.js";

function formatUsd(n: number): string {
  return `$${n.toFixed(2)}`;
}

export function CostBanner(): JSX.Element | null {
  const cost = useCompositionStore((s) => s.cost);
  if (!cost.loaded || cost.capUsd === 0) return null;
  const ratio = cost.spentUsd / cost.capUsd;
  const text = `${formatUsd(cost.spentUsd)} / ${formatUsd(cost.capUsd)}`;
  if (ratio >= 1.0) {
    return (
      <div
        role="alert"
        className="w-full rounded bg-accent-danger/20 px-3 py-1.5 text-sm text-accent-danger"
      >
        Monthly cost cap reached — new generations will be blocked ({text})
      </div>
    );
  }
  const tone = ratio >= 0.8 ? "active" : "neutral";
  return <Badge tone={tone}>{text}</Badge>;
}
